if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 500)
          );

          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector('button');

              if (!button) return;

              button.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
            });

          if (
            this.dataset.desktopLayout &&
            this.dataset.desktopLayout.includes('thumbnail') &&
            this.mql.matches
          ) {
            this.removeListSemantic();
          }
        }
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const currentElement = event?.detail?.currentElement;

        if (!currentElement) return;

        const mediaId = currentElement.dataset.mediaId;

        if (!mediaId) return;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }

      filterMediaSet(setName) {
        const activeSetName = (setName || '').trim();
        const containers = [this.elements.viewer, this.elements.thumbnails].filter(Boolean);

        containers.forEach((container) => {
          container.querySelectorAll('[data-set-name]').forEach((item) => {
            const itemSetName = (item.dataset.setName || '').trim();
            const shouldHide = Boolean(activeSetName && itemSetName !== activeSetName);
            item.classList.toggle('hide', shouldHide);

            if (shouldHide) {
              item.classList.remove('is-active');
              item.querySelector('button')?.removeAttribute('aria-current');
            }
          });
        });
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;

        const mediaItems =
          this.elements.viewer.querySelectorAll('[data-media-id]');

        if (!mediaItems.length) return;

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) || mediaItems[0];

        if (!activeMedia) return;

        this.filterMediaSet(activeMedia.dataset.setName);

        /*
         * 清除旧 active 状态
         */
        mediaItems.forEach((element) => {
          element.classList.remove('is-active');

          /*
           * 清除可能由主题脚本遗留的隐藏样式
           */
          if (element !== activeMedia) {
            element.style.visibility = '';
            element.style.opacity = '';
            element.style.height = '';
          }
        });

        /*
         * 激活目标媒体
         */
        activeMedia.classList.add('is-active');

        /*
         * 防止主图被隐藏或高度塌陷
         */
        activeMedia.style.display = '';
        activeMedia.style.visibility = 'visible';
        activeMedia.style.opacity = '1';
        activeMedia.style.height = 'auto';

        this.elements.viewer.style.display = '';
        this.elements.viewer.style.visibility = 'visible';
        this.elements.viewer.style.opacity = '1';
        this.elements.viewer.style.height = 'auto';

        /*
         * 某些变体切换会把对应图片移到第一位
         */
        if (prepend) {
          if (
            activeMedia.parentElement &&
            activeMedia.parentElement.firstElementChild !== activeMedia
          ) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement &&
              activeThumbnail.parentElement.firstElementChild !==
                activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (
            this.elements.viewer.slider &&
            typeof this.elements.viewer.resetPages === 'function'
          ) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        /*
         * 让目标图片滚动到主图库可视区域
         */
        window.setTimeout(() => {
          const parent = activeMedia.parentElement;

          if (parent && typeof parent.scrollTo === 'function') {
            parent.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth',
            });
          }

          const activeMediaRect =
            activeMedia.getBoundingClientRect();

          /*
           * 如果图片已经在视口，不滚页面
           */
          if (activeMediaRect.top > -0.5) return;

          const top =
            activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        }, 50);

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);

        const mediaPosition =
          activeThumbnail.dataset.mediaPosition;

        if (mediaPosition) {
          this.announceLiveRegion(
            activeMedia,
            mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        const button =
          thumbnail.querySelector('button');

        if (button) {
          button.setAttribute(
            'aria-current',
            'true'
          );
        }

        /*
         * 有些主题不是 slider custom element，
         * 所以先判断函数是否存在
         */
        if (
          typeof this.elements.thumbnails.isSlideVisible ===
          'function'
        ) {
          if (
            this.elements.thumbnails.isSlideVisible(
              thumbnail,
              10
            )
          ) {
            return;
          }
        }

        if (
          this.elements.thumbnails.slider &&
          typeof this.elements.thumbnails.slider.scrollTo ===
            'function'
        ) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
            behavior: 'smooth',
          });

          return;
        }

        /*
         * fallback
         */
        if (
          typeof thumbnail.scrollIntoView ===
          'function'
        ) {
          thumbnail.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        }
      }

      announceLiveRegion(
        activeItem,
        position
      ) {
        if (
          !this.elements.liveRegion ||
          !activeItem
        ) {
          return;
        }

        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          ) ||
          activeItem.querySelector('img');

        if (!image) return;

        const announce = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            'false'
          );

          if (
            window.accessibilityStrings &&
            window.accessibilityStrings.imageAvailable
          ) {
            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings.imageAvailable.replace(
                '[index]',
                position
              );
          }

          window.setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              'true'
            );
          }, 2000);
        };

        if (image.complete) {
          announce();
        } else {
          image.onload = announce;
        }
      }

      playActiveMedia(activeItem) {
        if (!activeItem) return;

        if (
          typeof window.pauseAllMedia ===
          'function'
        ) {
          window.pauseAllMedia();
        }

        const deferredMedia =
          activeItem.querySelector(
            '.deferred-media'
          );

        if (
          deferredMedia &&
          typeof deferredMedia.loadContent ===
            'function'
        ) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            'sticky-header'
          );

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event(
            'preventHeaderReveal'
          )
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer) return;

        if (
          !this.elements.viewer.slider
        ) {
          return;
        }

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        if (
          this.elements.viewer.sliderItems
        ) {
          this.elements.viewer.sliderItems.forEach(
            (slide) => {
              slide.setAttribute(
                'role',
                'presentation'
              );
            }
          );
        }
      }
    }
  );
}
